const DARK = 'dark';
const LIGHT = 'light';

export default {
    DARK,
    LIGHT,
};
